/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Seo_Measured_Subject_EndpointInputs */

const en_seo_measured_subject_endpoint = /** @type {(inputs: Seo_Measured_Subject_EndpointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action}`)
};

const zh_hans1_seo_measured_subject_endpoint = /** @type {(inputs: Seo_Measured_Subject_EndpointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action}`)
};

const pt_br2_seo_measured_subject_endpoint = /** @type {(inputs: Seo_Measured_Subject_EndpointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ao endpoint ${i?.action} da API para ${i?.name}`)
};

const es_seo_measured_subject_endpoint = /** @type {(inputs: Seo_Measured_Subject_EndpointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`al endpoint ${i?.action} de la API de ${i?.name}`)
};

const fr_seo_measured_subject_endpoint = /** @type {(inputs: Seo_Measured_Subject_EndpointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action}`)
};

const de_seo_measured_subject_endpoint = /** @type {(inputs: Seo_Measured_Subject_EndpointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action}`)
};

const ru_seo_measured_subject_endpoint = /** @type {(inputs: Seo_Measured_Subject_EndpointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action}`)
};

const it_seo_measured_subject_endpoint = /** @type {(inputs: Seo_Measured_Subject_EndpointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action}`)
};

/**
* | output |
* | --- |
* | "{name} {action}" |
*
* @param {Seo_Measured_Subject_EndpointInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_measured_subject_endpoint = /** @type {((inputs: Seo_Measured_Subject_EndpointInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Measured_Subject_EndpointInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_measured_subject_endpoint(inputs)
	if (locale === "pt-BR") return pt_br2_seo_measured_subject_endpoint(inputs)
	if (locale === "es") return es_seo_measured_subject_endpoint(inputs)
	if (locale === "fr") return fr_seo_measured_subject_endpoint(inputs)
	if (locale === "de") return de_seo_measured_subject_endpoint(inputs)
	if (locale === "ru") return ru_seo_measured_subject_endpoint(inputs)
	if (locale === "it") return it_seo_measured_subject_endpoint(inputs)
	return en_seo_measured_subject_endpoint(inputs)
});